// extracted by mini-css-extract-plugin
export default {"container":"NetworksPage_container__sugJT"};